import 'css-chunk-1JavaScriptSource/components/input-units/style.module.scss';export default {
  "control": "_control_1rtqg_1",
  "icon": "_icon_1rtqg_14",
  "short": "_short_1rtqg_19"
};